import React, { useEffect } from "react";
import Button from "../../../../ui/components/Button";
import { initializeGameArtAssets } from "../../../../ai/GameArtAI";
import { useGameArt } from "../../../../backend/useGameArt";

interface DebugGameArtButtonProps {
  config: any;
  gameId: string;
  incrementGameArtTriggerReload: () => void;
  gameCreateCompleted: boolean;
}

const DebugGameArtButton: React.FC<DebugGameArtButtonProps> = ({ config, gameId, incrementGameArtTriggerReload, gameCreateCompleted }) => {
  const { listGameArt } = useGameArt();

  const checkForGameArt = async () => {
    try {
      const existingGameArt = await listGameArt(gameId);
      if (existingGameArt.length > 0) {
        // console.log(`Game art already exists for gameId: ${gameId}. Number of assets: ${existingGameArt.length}`);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      // console.error('Error checking for existing game art:', error);
      return false; // Return false on error to prevent unintended clicks
    }
  };

  const initGameArt = async () => {
    const gameArtResult = await initializeGameArtAssets(gameId);
    // console.log('Game Art Result:', gameArtResult);
    if (!config.USE_NEW_GAME_ART_HISTORY) {
      incrementGameArtTriggerReload();
    }
  };

  const onClick = () => {
    // console.log('DebugGameArtButton clicked');
    initGameArt();
  };

  useEffect(() => {
    const checkAndClick = async () => {
      if (gameCreateCompleted) {
        const artExists = await checkForGameArt();
        if (!artExists) {
          // console.log('Auto-triggering initGameArt');
          initGameArt();
        }
      }
    };

    if (config.GAME_ASSETS_INTEGRATION.auto_trigger_init) {
      checkAndClick();
    }
  }, [gameCreateCompleted, gameId]);

  if (config.GAME_ASSETS_INTEGRATION.debug_init_button) {
    return (
        <Button 
          size="tiny" 
          color="ghost white" 
          text="Game Art" 
          onClick={onClick} 
        />
    );
  } else {
    return null;
  }
};

export default DebugGameArtButton;